import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

interface IGetCategoryPayload {
  id: number | string;
  lang?: string;
}

interface IGetAllCategoriesPayload {
  lang: string;
}

export const categorySlice = createApi({
  reducerPath: 'category',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as RootState).isAuth.isAuth;
      const lang = (getState() as RootState).language.lang;
      const publicEndpoints = ['getAllCategories', 'getCategory'];
      const isPublic = publicEndpoints.includes(endpoint);
      if (token && !isPublic) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Accept-Language', lang);
      return headers;
    }
  }),
  tagTypes: ['Categories'],
  endpoints: (builder) => ({
    getAllCategories: builder.query<IAnyResponse, IGetAllCategoriesPayload>({
      query: (payload) => ({
        url: `/categories`,
        method: 'GET'
      })
    }),

    getCategory: builder.query<IAnyResponse, IGetCategoryPayload>({
      query: (payload) => ({
        url: `/category/${payload.id}`,
        method: 'GET'
      })
    })
  })
});

export const { useGetAllCategoriesQuery, useGetCategoryQuery } = categorySlice;
